import { createStore, applyMiddleware, compose } from "redux";
// import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";

import CombinedReducer from "./CombinedReducer";
import { loadState, saveState } from "./localStorage";

// let createHistory = require("history").createBrowserHistory;

const persistedState = loadState();
const enhancers = [];
const middleware = [thunk];

if (process.env.NODE_ENV === "development") {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
    if (typeof devToolsExtension === "function") {
        enhancers.push(devToolsExtension());
    }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(CombinedReducer, persistedState, composedEnhancers);

// ========================================================
// Persist data on page refresh
// ========================================================
store.subscribe(() => {
    saveState(store.getState());
});

export default store;
